import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=2ed40400&scoped=true&"
import script from "./EditEvent.vue?vue&type=script&lang=ts&"
export * from "./EditEvent.vue?vue&type=script&lang=ts&"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=2ed40400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed40400",
  null
  
)

export default component.exports